import axios from 'axios';

import { environment, LocalStorange } from '../../../environment';
import { errorInterceptor, responseInterceptor } from './interceptor';

const env = environment();

const Api1 = axios.create({
    baseURL: env.baseUrl,
    headers: {
        'Authorization': `Bearer ${getToken()}`,
        'Access-Control-Allow-Origin': '*',
        'accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
    }
});

Api1.interceptors.response.use(
    (response: any) => responseInterceptor(response),
    (error: any) => errorInterceptor(error),
);

export { Api };

export function getToken() {

    let token = null;

    const userToken = localStorage.getItem(LocalStorange.USERINFO);
    if (userToken !== null) {
        token = JSON.parse(userToken);
    }
    return (
        token !== null ? token.user.token : ''
    );
}

const Api = axios.create();

// Request interceptor for API calls
Api.interceptors.request.use(
    async config => {
        config.baseURL = env.baseUrl;
        config.headers = {
            'Authorization': `Bearer ${getToken()}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            'Access-Control-Allow-Origin': '*'
        };
        return config;
    },
    error => {
        Promise.reject(error);
    });

// Response interceptor for API calls
Api.interceptors.response.use((response) => {
    return response;
}, async function (error) {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const access_token = await getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        return Api(originalRequest);
    }
    return Promise.reject(error);
});